export enum DragDropEnum {
    FORM = "Form",
    FORM_TEMPLATE = "Form Template",
    FOLDER = "Folder",
    FORM_TEMPLATE_CATALOG = "Form Template Catalog",
    DRAGGED_ITEMS = 'draggedItems',
    TEXT_FORMAT = 'text/JSON'
}
